module.exports = __webpack_public_path__ + "img/2.3e8bfaf3.png";